<template>
    <div id="service">
        <tabtop></tabtop>
        <div class="about1">
            <img :src="url+banner.images[1]" alt="" @click="jumpbannerpage(banner2.url,index)">
        </div>
        <div class="about6">
            <p class="title">服务答疑</p>
            <el-menu :default-active="activeIndex1" class="el-menu-demo" mode="horizontal" @select="handleSelect1">
                <el-menu-item v-for="(item,index) in about6.tab1" :key="index" :index="index">{{item.title}}</el-menu-item>
            </el-menu>
            <ul class="about6lList">
                <li>
                    <el-menu :default-active="activeIndex2" class="el-menu-vertical-demo" mode="vertical" >
                        <el-submenu v-for="(item,index) in about6.tab2" :key="index" :index="index">
                            <template slot="title">
                                <span>{{item.title}}</span>
                            </template>
                            <el-menu-item-group >
                                <el-menu-item v-for="(list,i) in item.tab3" :key="i" :index="index+'-'+i" @click="handleSelect2(index,i)">{{list.title}}</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                    </el-menu>
                </li>
                <li class="right">
                    <p class="about6Title">{{about6.activeArticle.title}}</p>
                    <div class="about6Content" v-html="about6.activeArticle.content"></div>
                </li>
            </ul>
        </div>
        <webbottom></webbottom>
    </div>
</template>

<script>
var that
import { rotationmap,service } from '@/api/api'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    name:"about",
    components: {
        tabtop,
        webbottom
    },
    data(){
        return {
            data:[],
            url : window.url,
            banner: [
                {
                    image: "/uploads/20230106/d7ffba6b58a6520e5449b0b0bad81f68.png",
                },
                {
                    image: "/uploads/20230106/68effa4c92a24b9c1d93334f41605ef9.png",
                },
                {
                    image: "/uploads/20230106/7275ee98ff21dc2ba649cc00ea4d818b.png",
                },
                {
                    image: "/uploads/20230106/6d55174aa25e4ee16f53307d1d9c0d99.png",
                },
                {
                    image: "/uploads/20230106/69e4dfdecfcdaa6956a997fdd417ce46.png",
                },
                {
                    image: "/uploads/20230106/865e4c39e77416c4ad0e8c7e94900295.png",
                },
                {
                    image: "/uploads/20230106/1791c65d4c1be2b8ad015f4eb084031b.png",
                },
                {
                    image: "/uploads/20230106/1de54a0d841edcc5448690360fd629c5.png",
                }
            ], 
            activeIndex1:'0',
            activeIndex2:'0',
            about6:{
                tab1:[],
                tab2:[

                ],
                activeArticle:{

                }
            }
        }
    },
    mounted(){
        that =this
        rotationmap({'type':6}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
        })
        service().then((response) => {
            //初始化动画
            that.$nextTick(()=>{
                that.$wow.init()
            })
            that.data = response.data.data 
            for(let i=0;i<response.data.data.length;i++){
                if(response.data.data[i].parent_id==1){
                    that.about6.tab1.push(response.data.data[i])
                }
                if(response.data.data[i].parent_id==that.about6.tab1[0].id){
                    response.data.data[i].tab3 = []
                    that.about6.tab2.push(response.data.data[i]) 
                }
                for(let y=0;y<that.about6.tab2.length;y++){
                    if(response.data.data[i].parent_id==that.about6.tab2[y].id){
                        that.about6.tab2[y].tab3.push(response.data.data[i])
                    }
                }
            }
            that.about6.activeArticle = that.about6.tab2[0].tab3[0]
        })
    },
    methods:{
        handleSelect1(e){
            that.about6.tab2 = []
            for(let i=0;i<that.data.length;i++){
                if(that.data[i].parent_id==that.about6.tab1[e].id){
                    that.data[i].tab3 = []
                    that.about6.tab2.push(that.data[i]) 
                }
                for(let y=0;y<that.about6.tab2.length;y++){
                    if(that.data[i].parent_id==that.about6.tab2[y].id){
                        that.about6.tab2[y].tab3.push(that.data[i])
                    }
                }
            }
        },
        handleSelect2(e,y){
            that.about6.activeArticle = that.about6.tab2[e].tab3[y]
        },
        jumpbannerpage(e,y){
            let url = e.split(';')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        }
    }
}
</script>

<style lang="less">
@media (min-width:750px) {
    #service{
        .about1{
            img{
                width: 100%;
                display: block;
            }
        }
        .about6{
            width: 1300px;
            margin:70px auto 0;
            .title{
                font-size: 32px;
                color: #333333;
                position: relative;
                width: 266px;
                margin:0 0 50px;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 8px;
                height: 100%;
                background: #5B7CFA;
                left: -22px;
                top: 0px;
            }
            .about6lList{
                display: flex;
                .el-menu-vertical-demo{
                    width: 200px;
                }
                .el-menu-item{
                    width: 100px;
                    white-space: nowrap;
                    overflow: hidden;//文本超出隐藏
                    text-overflow: ellipsis;//文本超出省略号替代
                }
                .right{
                    padding: 24px 26px;
                    .about6Title{
                        font-size: 30px;
                        font-weight: 400;
                        color: #343434;
                        border-bottom: 1px solid #DCDCDC;
                        margin-bottom: 20px;
                        padding-bottom: 20px;
                    }
                    .about6Content{
                        font-size: 22px;
                        font-weight: 400;
                        color: #343434;
                    }
                }
            }

        }
    }
}
@media screen and (max-width:750px) {
    #service{
        .about1{
            img{
                width: 100%;
                display: block;
            }
        }
        .about6{
            width: 98%;
            margin:10px auto 0;
            .title{
                font-size: 32px;
                color: #333333;
                position: relative;
                width: 266px;
            }
            .title::after{
                content:"";
                display: block;
                position: absolute;
                width: 8px;
                height: 100%;
                background: #5B7CFA;
                left: -22px;
                top: 0px;
            }
            .about6lList{
                display: flex;
                .el-menu-vertical-demo{
                    width: 100px;
                }
                .right{
                    padding: 12px 14px;
                    .about6Title{
                        font-size: 16px;
                        font-weight: 400;
                        color: #343434;
                        border-bottom: 1px solid #DCDCDC;
                        margin-bottom: 10px;
                        padding-bottom: 10px;
                    }
                    .about6Content{
                        font-size: 12px;
                        font-weight: 400;
                        color: #343434;
                    }
                }
            }

        }
    }
}
</style>